<template>
  <RouterView />
  <SessionTimer v-if="auth.isAuthenticated" />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import SessionTimer from '@/components/auth/SessionTimer.vue'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
</script>
